import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { Wordmark } from "./wordmark";
import { useAuth } from "@/providers/auth.provider";
import { AuthState } from "@/types/auth.types";

const PUBLIC_LINKS = [
  { title: "Features", to: "/features" },
] as const;

const Header = () => {
  const { authState } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b-2 border-brand bg-background">
      <div className="mx-auto flex h-14 w-full max-w-[1280px] items-center gap-4 sm:gap-6 px-4 sm:px-7">
        <Link to="/" aria-label="Home">
          <Wordmark />
        </Link>
        <nav aria-label="Primary" className="flex items-center gap-3 sm:gap-[18px]">
          {PUBLIC_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-[14px] transition-colors"
              inactiveProps={{ className: "text-muted-foreground hover:text-foreground" }}
              activeProps={{ className: "text-brand font-semibold" }}
            >
              {l.title}
            </Link>
          ))}
        </nav>
        <div className="ml-auto">
          {authState === AuthState.UNAUTHENTICATED && (
            <Button asChild size="sm">
              <Link to="/login">Sign in</Link>
            </Button>
          )}
          {authState === AuthState.AUTHENTICATED && (
            <Button asChild size="sm" variant="outline">
              <Link to="/dashboard">Open the app</Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
